import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./course-page.scss";
import Dropdown from "react-bootstrap/Dropdown";
import { allCourses, lecturers } from "../../TextData";
import { Courses } from "../../components/Courses/Courses";
import { Lecturers } from "../../components/Lecturers/Lectuerers";
import { Carousel } from "@trendyol-js/react-carousel";
import Image4 from "../../assets/images/cap.webp";

export const CoursePage = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const handleClick = (index) => setActiveIndex(index);
  const checkActive = (index, className) =>
    activeIndex === index ? className : "";

  const [widthM, setWidth] = useState(window.innerWidth);
  const [isMobile, setMobile] = useState(window.innerWidth <= 768);
  const [category, setCategory] = useState("*");
  const [filteredCourses, setFilteredCourses] = useState(allCourses);
  function setCat(cat) {
    setCategory(cat);
  }
  useEffect(() => {
    if (category === "*") {
      setFilteredCourses(allCourses);
    } else {
      setFilteredCourses(
        allCourses.filter((prd) => prd.category.indexOf(category) !== -1)
      );
    }
  }, [category]);
  const [state, setState] = useState({
    query: "",
    list: lecturers,
  });
  return (
    <>
      <div className="course-page">
        <center>
          <h1>UNDERGRADUATE COURSES</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Courses</h6>
        </div>
      </div>
      <div className="col-md-6 offset-md-3 flexy course-filter">
        <div className="col-md-3">
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              All
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setCat("*")}>
                View all courses
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-3">
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              Filter by year
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setCat("year1")}>
                Year1
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("year2")}>
                Year2
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("year3")}>
                Year3
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("year4")}>
                Year4
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-3">
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              Filter by unit load
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setCat("unitload1")}>
                1 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload2")}>
                2 unit load
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("unitload3")}>
                3 unit load
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("unitload4")}>
                4 unit load
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("unitload5")}>
                5 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload6")}>
                6 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload7")}>
                7 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload8")}>
                8 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload9")}>
                9 unit load
              </Dropdown.Item>{" "}
              <Dropdown.Item onClick={() => setCat("unitload10")}>
                10 unit load
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-3">
          <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              Filter by choice
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setCat("compulsory")}>
                Compulsory
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setCat("elective")}>
                Electives
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="col-md-12  mt">
        <div className="offset-md-2 col-md-8 ">
          <section className="row row-cols-2 row-cols-lg-4  g-lg-4 col-md-12">
            {filteredCourses.map((data, index) => (
              <Courses data={data} />
            ))}
          </section>
        </div>
      </div>

      <div className="col-md-8 offset-md-2 mt transaction-page">
        <center>
          <h2>UNDERGRADUATE COURSE DESCRIPTION</h2>
        </center>
        <div className="tabs mt6">
          <button
            className={`tab ${checkActive(1, "active2")}`}
            onClick={() => handleClick(1)}
          >
            100 Level
          </button>
          <button
            className={`tab ${checkActive(2, "active2")}`}
            onClick={() => handleClick(2)}
          >
            200 Level
          </button>
          <button
            className={`tab ${checkActive(3, "active2")}`}
            onClick={() => handleClick(3)}
          >
            300 Level
          </button>{" "}
          <button
            className={`tab ${checkActive(4, "active2")}`}
            onClick={() => handleClick(4)}
          >
            400 Level
          </button>{" "}
        </div>
        <div className="panels">
          <div className={`panel ${checkActive(1, "active2")}`}>
            <h3>100 Level</h3>
            <h4>
              PHY 101.1 Introduction to Mechanics and Properties of Matter{" "}
            </h4>
            <p>
              Topics covered in this course will include the following: Motion
              in one dimension, motion in plane, work and energy, conservation
              laws, collision, solid friction, rota­tional kinematics and
              rotational dynamics, equilibrium of rigid bodies, oscillations,
              gravitation, fluid statics and fluid dynamics. Surface tension,
              Viscosity and Hydro­statics.{" "}
            </p>
            <h4>PHY 102.1: Laboratory practice I</h4>
            <p>
              This course emphasizes experimental verification and quantitative
              measurements of physics laws, treatment of measurements errors and
              graphical analysis. The experiments include studies of mechanical
              systems, static and rotational dynamics of rigid bodies,
              viscosity, elasticity, surface tension and hydrostatics.
            </p>
            <h4>BIO 101.1: General Biology</h4>
            <p>
              History of Science of Biology, Subdivisions or Branches of
              Biology, Characteristics of Living things, Differences between
              Plants and Animals, Classification of Living things into Kingdoms,
              Importance of Biology to man, History of Cell concepts and theory,
              The general structure of Plant and Cell, Ultra-Structures of the
              cell and their function, Chemical properties of cells, Cell and
              its Environment, Cell types in Plant and Animal Division and
              Molecular basis of heredity.
            </p>
            <h4>MTH 110.1 Algebra and Trigonometry</h4>
            <p>
              Elementary notations of set, subsets, unions, intersection,
              compliments, Venn diagrams. Real numbers, integers, rational and
              irrational numbers, mappings of a set. Real functions and their
              decomposition. Quadratic functions, Cubic functions and Roots of
              quadratic and cubic functions. Equations with complex roots,
              Complex numbers and Geometric representation of complex numbers.
              De Moirvers series and sequences and Principle of Mathematical
              Induction. Binomial theorem, Trigonometric function of angles and
              Circular functions. Addition theorems, Double and half angles.
            </p>
            <h4>MTH 120.1 Calculus</h4>
            <p>
              The straight line, parallel and perpendicular lines, angle between
              two straight lines, the distance of points from a line, parametric
              equations, tangents and normals, limits and continuity.
              Differentiability, the derivative of simple algebraic functions,
              rules of differentiation, maxima and minima, integration as the
              inverse of differen­tiation. Integration as the limit of a sum,
              area under the curves and volumes.
            </p>
            <h4>CHM 130.1 General Chemistry I</h4>
            <p>
              Basic principles of matter and energy from the chemist’s point of
              view. A broadly based course suitable for students from various
              schools as well as those from the Faculty of Science. Topics to be
              covered will include atomic theory and molecular structure,
              stoichiometry, the periodic classification of the elements, atomic
              solu­tions, and chemical equilibrium. Ionic equilibrium, chemical
              thermodynamics, elec­trochemistry and chemical kinetics.
            </p>{" "}
            <h4>GES 100.1 Communication Skill in English </h4>
            <p>
              The course seeks to develop the students a well-informed attitude
              to the English language and to equip them with the knowledge of
              English communication and study skill that will facilitate their
              work in university and beyond.
            </p>{" "}
            <h4>GES 102.1 Introduction to Logic and Philosophy</h4>
            <p>
              A brief survey of the scope, notions, branches and problems of
              philosophy sym­bolic logic, specific symbolic logic. Conjunction,
              affirmation, negations, disjunction, equivalence and conditional
              statements. Law of thought. The method of deduction, using rule of
              inference and bi-conditions. Quantitative theory.
            </p>{" "}
            <h4>PHY 112.2 Introduction to Electricity and Magnetism</h4>
            <p>
              This is the introductory course on Electricity and Magnetism.
              Topics covered all will include: The Electric field, Gauss’s Law,
              Electric potential, Capacitor and Dielectric, current and
              resistance, electromotive force and circuits, the magnetic field,
              Am­pere’s Law, faraday’s Law of induction.
            </p>{" "}
            <h4>PHY 103.2 Laboratory Practice II</h4>
            <p>
              The experiment carried out in this course will cover areas
              discussed in PHY 112.2. These experiments include verifications of
              the current electricity, measurement of the electrical properties
              of conductors, D.C. and A.C. circuit properties, series and
              parallel resonant circuits, transformer characteristics and other
              electrical circuit problems.
            </p>{" "}
            <h4>PHY 115.2: Heat, Light and Optics</h4>
            <p>
              This course is designed for students in the Biological Sciences
              (Botany, Microbiol­ogy and Zoology). Topics to be covered in the
              course will include: thermometry, calorimetry and heat transfer.
              Geometrical optics will include reflection and refrac­tion of
              light at the plane and curved surfaces and optical instruments.
              Properties and propagation of sound waves. Sound waves propagating
              in air columns. Dop­pler effect.
            </p>{" "}
            <h4>MTH 124.2: Coordinate Geometry</h4>
            <p>
              Straight lines, circles parabola, ellipse, hyperbola. Tangent and
              normal. Addition of Vectors, Scalar and Vector products; Vector
              operations of a line and plane. Kine­matics of a particle.
              Components of velocity and acceleration of a particle moving in a
              plane. Force, momentum, laws of motion under gravity, projectiles,
              resisted vertical motion, elastic string, simple pendulum,
              impulse, impact of two smooth spheres and a sphere on a smooth
              sphere.
            </p>{" "}
            <h4>CHM 131.2 General Chemistry II</h4>
            <p>
              Application of the principles of chemical and physical change to
              the study of the behaviour of matter and the interaction between
              matters. Course content includes: the chemistry of the
              representative elements and their common compounds with emphasis
              on graduation of their properties, brief chemistry of the first
              series of transition elements, general principles of extraction of
              metals introductory nuclear chemistry.
            </p>{" "}
            <h4>GLY 101.2: Planet Earth </h4>
            <p>
              The course teaches the student the following: Origin of the
              Universe and the solar system. Structure and composition of the
              earth. The common rock-forming miner­als. The major rock groups.
              Elements of structural Geology and Crystallography. Surface
              processes (Weathering, erosion, transportation and deposition).
              Elements of Historical geology, palaeontology and stratography.
              Concepts of Paleogeogra­phy, paleoclimatology pale environment,
              palaeoceanography and pale magnetism. Introduction to concepts of
              continental drift, sea floor spreading and plate tectonics.
            </p>{" "}
            <h4>GLY 102.2 Introduction Lab/Field Practice in Geology</h4>
            <p>
              This is purely a Laboratory and fieldwork course. It includes
              megascopic identification of common rock-forming minerals and
              common rock types. Interpretations of simple topographic and
              geologic maps. Identification of index macrofossils and
              correlation exercises and geochemical analysis.
            </p>
            <h4>GES 101.2 Computer Appreciation and Applications</h4>
            <p>
              History of Computers, Generation and Classification of Computers;
              IPO model of a computer, Components of a computer system-
              hardware’s and Software’s; Pro­gramming Language, Organization of
              Data, Data Computer techniques; Introduc­tion to computer
              Networks; Software and its applications; Use of key board as an
              input device; DOS, Windows, Word processing Spreadsheets;
              Application of Com­puters in Medicine, Social Sciences,
              humanities, Education Management Sci­ences.
            </p>
            <h4>GES 103.2: Nigerian People and Culture</h4>
            <p>
              The overall objective of this course is to help students
              understand the concept of culture and its relevance to human
              society especially as it relates to development. In more specific
              terms, the course will be designed to help the students know the
              history of various Nigerian cultures beginning with pre-colonial
              Nigeria society. Colonialism constitutes a vital watershed in
              Nigerian history. Thus, the course will:
              <ol>
                <li>
                  Identify the influence of colonialism on Nigerian culture.
                </li>
                <li>
                  Focus on contemporary Nigerian culture explaining issues that
                  relate to the political economic, educational, religious and
                  social institutions in the nation.
                </li>
              </ol>
            </p>
            <p>
              <strong> The course outline includes: </strong>The concept of
              culture; pre-colonial culture and Languages of Nigeria; principles
              of kinship, decent and marriage in Nigerian cul­tures; the
              colonial impact; Nigerian economic institutions; Education and
              develop­ment in Nigeria; Religion in Nigerian culture; culture,
              environment and health prac­tices in Nigeria; Intergroup
              relations.
            </p>
          </div>
          <div className={`panel ${checkActive(2, "active2")}`}>
            {" "}
            <h3>200 Level</h3>
            <h4>PHY 200.1: Energy, Environment and Basic Space Science</h4>
            <p>
              The principles, demands and outlook for power and energy.
              Transformation of energy, its cost and pollution. Principles and
              problems of electrical energy from fossil and hydroelectric
              generation; their cost, capacity, storage, reserve, efficiency and
              consequent environmental effects. Electrical energy from nuclear
              water power, geothermal power, tidal power, wind power, etc.
              promise and problems of such unconventional energy sources,
              introduction to Astronomy and Astrophysics, Satellite
              Communication, introduction to atmospheric Science, Space
              Environment, Space craft systems and Dynamics, Aero/Astrodynamics
              Engineering, Rocket Engineering, Cosmology, Origin of the universe
              and life, space law and Business development.
            </p>{" "}
            <h4>PHY 206.1: Laboratory Practice III</h4>
            <p>
              The laboratory course consists of experiments drawn from
              electromagnetism and modern physics. Such experiments will
              include: measurement of specific charge, verification of the Hall
              effect, electron motion in electric and magnetic fields;
              ex­periments with the Geiger Mueller tube; the Frank-Hertz
              experiment and the Photo-electric effect.
            </p>{" "}
            <h4>PHY 210.1: Physics of the Solid Earth</h4>
            <p>
              This course is an introduction to concepts such as the internal
              structure and composition of the earth, the Earth’s magnetic field
              and distribution, electrical theory of the earth’s core,
              generation of the earth’s magnetic field. The theory of plate
              tectonics, continental drift, sea floor spreading and driving
              force of plate tectonics.
            </p>{" "}
            <h4>PHY 216.1: Vibrations and Waves</h4>
            <p>
              This course is an introduction to oscillations and waves
              phenomena. Topics cov­ered will include vibrations and waves,
              electromagnetism waves, vibrating sys­tems, types of waves, sound
              waves and wave optics.
            </p>{" "}
            <h4>MTH 210.1: Linear Algebra</h4>
            <p>
              Definition of a function, sequences and series of real numbers,
              theory of functions of single variable.
            </p>{" "}
            <h4>MTH 280.1: Introduction to Computer Programming</h4>
            <p>
              Historical details of Computers, principles of programming.
              Programming with FORTRAN Language.
            </p>{" "}
            <h4>STA 260.1: Introduction to Probability and Statistics</h4>
            <p>
              Definition of Probability, frequency and probability of events.
              Equally likely events, counting technique. Conditional probability
              (Baye’s Theorem), independent events, random variables,
              probability distributions. The central limit theorem, mathematical
              expectation, moments, the mean, variance, variance of sum,
              co-variance and correlation, conditional expectation. Analysis of
              variance plus contingency table plus non-parametric inference.
            </p>{" "}
            <h4>GLY 201.1 Stratigraphy and Historical Geology</h4>
            <p>
              Element of Chrono, Litto, Bio, Magneto and Seismic stratigraphy.
              Global regression and transgression. Principles of stratigraphy.
              Stratigraphic terminology, nomenclature, classification and
              procedure. Stratigraphic correlation, facies analysis. Basins and
              stratigraphic evolution of sedimentary basins (emphasize Benue
              Trough) and Geohistory analysis. Practical to include facies map,
              correlation and stratigraphic cross-sections.
            </p>{" "}
            <h4>GLY 202.1: Structural Geology </h4>
            <p>
              Fundamentals of structural Geology. Description, genesis,
              classifications and interpretations of deformational structures.
              Unconformities, faults, folds and struc­tural features related to
              igneous activity etc. Practical to include: three (3) point
              problems, interpretation of geologic and aerial photomaps.
            </p>{" "}
            <h4>SLT 201.1 Photography and Illustration</h4>
            <p>
              <strong>
                Concepts and Fundamentals of Photography, Cameras:
              </strong>{" "}
              The general principles, manipulation and care of different types
              of cameras, a common use, their advantages and disadvantages.
              <strong>Photomicrography: </strong>Techniques and applications,
              lighting system, Daylight, ‘Photoflood”. Explosive meters, depth
              of field background.{" "}
              <strong>Print process projection and contact printing,</strong>
              Choice and grades of paper, local control, finishing, colour
              photography, principles of reversal and of negative – positive
              processes. Types of material, colour temperature, filters,
              exposure materials, exposure. <strong>
                Cine, photography:
              </strong>{" "}
              Cine photography, use of signor camera, video camera, splicing and
              editing of commercially processors film. hazards in the use of
              <strong>Safety:</strong> photographic reagents, Darkroom
              management.
            </p>{" "}
            <h4>PHY 205.2: Thermal Physics</h4>
            <p>
              The three parts of his course are heat, under which thermometry,
              Calorimetry and heat transfer are discussed. Thermodynamics –
              treat the kinetic theory of an ideal gas, equation of state,
              reversible adiabatic and isothermal processes, the first and
              second laws of thermodynamics including their consequences; and
              Geometrical optics which discusses the fundamental principles of
              reflection and refraction at plane and curved surfaces; emission
              and absorption spectra and optical instru­ments.
            </p>
            <h4>MTH 250.2: Elementary Differential Equations</h4>
            <p>
              First order ordinary differential equations; Existence and
              uniqueness. Second order differential equations with constant
              coefficients. General theory of the nth order linear equations.
              Laplace transform solution of initial value problem. Sturn
              Lioville equations in two independent variables. Application of
              C.D.C. and P.D.E. of physical, life and social sciences.
            </p>
            <h4>PHY 207.2: Laboratory Practice</h4>
            <p>
              This laboratory course will include calorimetry and heat transfer
              experiments. Light interference and diffraction experiments,
              experiments with Michelson interferome­ter, Fresnel Biprism, Nicol
              prism, Polari meter and the Newton’s Ring experiment.
            </p>
            <h4>PHY 211.2: Quantum Mechanics I</h4>
            <p>
              Inadequacies of classical mechanics, differences between classical
              I and quantum mechanics; wave-particle properties, Heisenberg’s
              uncertainty principles, wave and state functions; principles of
              Quantum mechanics; Schrodinger’s wave me­chanics formulation,
              postulates of quantum mechanics, matrix representation of Quantum
              mechanics, time-independent Schrodinger’s wave equation; wave
              me­chanics for some simple system.
            </p>
            <h4>PHY 221.1: Mathematical Physics</h4>
            <p>
              This is an introductory mathematical methods course which is of
              particular interest to theoretical physics. Topics to be treated
              include introductory vector analysis; coordinate systems and their
              transformations. Motion in the various coordinate systems.
              Differential equations in two and three dimensions. Application of
              differ­ential equations (partial and whole) in mechanics, electric
              circuits, atomic and nuclear physics, and boundary value problems.
            </p>
            <h4>PHY 222.2 Analytical Mechanics I</h4>
            <p>
              Newtonian Mechanics. Motion of a particle in one, two and
              three-dimension, system of particles and collision theory,
              Newtonian gravitation, conservative forces and potentials,
              oscillations, central force problems, accelerated frames of
              reference, rigid body dynamics, generated motions; mechanics of
              continuum media. Fluid statics and dynamics.
            </p>
            <h4>PHY 231.2: Modern Physics</h4>
            <p>
              This is an introductory course on modern physics. Topic in atomic
              structure, photoelectric effect, black-body radiation, relativity,
              radioactivity, nuclear structure, mass spectrometers.
            </p>
            <h4>FCS 2C1.2 Community Services (See Faculty of Science)</h4>
            <h4>SLT 210.2 Workshop Technology III (Glass Blowing)</h4>
            <p>
              The course focuses on glass blowing practice with application in
              the teaching and research institution. Brief History of
              manufacture of glass, types of glasses, the composition of glass.
              Tropical glass blowing tools and accessories fuels gases and fuel
              limes. Dimension tolerances in tubing and rods. Basic operation in
              soak glass pulling points, Making test-tube ends joining two
              glasses in straight joints, spotting, T-joins, Y-pieces, Making
              seals – rings, multiple and internal seal Glass to metal seals,
              designs maintenance, repairs and construction of some basic and
              essential glass waves, e.g. burettes, pipettes, condensers,
              manometers, viscometers, drying tubes, grinding, flame polishing
              and annealing vacuum lines and accessories.
            </p>
          </div>
          <div className={`panel ${checkActive(3, "active2")}`}>
            <h3>300 Level</h3>
            <h4>PHY 300.1 Mathematics Physics II</h4>
            <p>
              This is a continuation of the first semester PHY 200.1. Topics
              covered in the course will include complex variables and
              application; Fourier series and transforms, Metric’s and
              determinants; special functions like Bessel functions, Languere
              functions and polynomials; Hermit function and polynomials;
              Lengendre equations and polynomials.
            </p>
            <h4>PHY 313.1 Electricity and Magnetism I</h4>
            <p>
              This course deals with the topics of electricity and magnetism
              seen in PHY 112.2 at a more advanced level. topics include
              electrostatics, solutions of Laplace’s Equations, dielectric,
              static magnetic fields, magnetic materials, electromagnetic
              induction and Maxwell’s Equation.
            </p>
            <h4>PHY 315.1 Electronics Instrumentation I</h4>
            <p>
              Introduction to the principles of measurement and control.
              Generalized approach to measuring systems. (Functional
              description, input-output configuration). Performance
              characteristics of instruments. Analysis of errors, units of
              measurements. Analytical techniques for system analysis.
              (Different domain, Review of Laplace transform, transfer
              function). Frequency response analysis, Rouith-Huwite stability
              criteria, Poles-zero plots. Bode plots and polar plots. Nyquist
              stability and principles and properties of feedback systems as
              applied to measurement systems. Control systems characteristics
              open and closed loop control systems.
            </p>
            <h4>PHY322.1 Analytical Mechanics II</h4>
            <p>
              Degrees of freedom, generalized coordinates, Lagrange’s
              formulation of mechanics, application, the calculus of variations
              and the action principle Hamiltonian’s formulation of mechanics,
              application. Invariance and conservation laws. Oscillatory systems
              including damped, forced and coupled oscillation, Normal modes.
            </p>
            <p>
              Degenerate and non-degenerate steady state permutation theory,
              identical particles, the matrix formulation of Quantum mechanics,
              Time-dependent perturbation theory, the relativistic wave
              equation, origin of the electron spin.
            </p>
            <h4>PHY 353.1 Electrical Circuit</h4>
            <p>
              This course introduces students to the application of various
              methods of analysing DC circuits cooking resistive elements and
              different types of sources (CC, CVS, CDCS, VDCS, CDVS, VDVS), such
              as Kirchhoff’s Law, Node method, Mesh method, superposition,
              theorems and Norton equivalent circuits and maximum power transfer
              theorems and application to transistor and Op-amp circuits. <br />
              CCS – Constant Curent Sources <br />
              CVS – Constant Voltage Sources <br />
              CDCS – Current-Dependent Curent Sources
              <br /> VDCS – Voltage-Dependent Curent Sources <br />
              CDVS – Current Dependent Voltage Sources.
            </p>
            <h4>PHY 361.1 Introduction to Applied Geophysics</h4>
            <p>
              This course introduces the students to the art of Geophysical
              exploration using seismic methods. At the end of the course, the
              student should have mastered theoretical aspects of seismic
              methods, including characteristics of elastic waves and their
              propagation. Reflection, Refraction, Generation of seismic waves,
              Instruments, Digital recording and Field Instrumentation.
            </p>
            <h4>
              PHY 320.1: Advanced Physics Laboratory/Workshop (For Physics
              student)
            </h4>
            <p>
              In the course, laboratory experiments are chosen from electronics,
              material science, atomic and nuclear, solid-state physics and the
              workshop course is intended to prepare the students for their
              research projects (PHY 449.0) by way of introducing them to the
              use of simple machine tools. Welding, soldering glass blowing,
              engineering drawing and design are also included
            </p>
            <h4>MTH 324.1 Complex Analysis I</h4>
            <p>
              Functions of a complex variable. Limits and continuum of functions
              of a complex variable. Differentiating. Cauchy-Rieman equations.
              Analytic functions. Bilateral transformations, conformal mapping,
              contour integrals. Cauchy’s theorem and its consequences.
              Convergence of sequences and series of function of a complex
              variable. Power series, Taylor series. Laurent expansion. Isolated
              singularities and residues.{" "}
            </p>
            <h4>PHY 345.2 Materials Science</h4>
            <p>
              This course aims at acquainting Materials science students with
              the introduction to material based on properties of solids,
              microstructure, forming and shaping operation. This should
              illustrate the importance of the range of currently available
              engineering materials and to show that technology development
              depends on (a) introducing new materials and new processes (b)
              awareness of limitations of existing materials and processes.
              Topics include: Basic unit of atoms and molecule and how materials
              are formed from the basic units. Atomic and atomic coordination,
              atomic order in solids and molecular disorder, single-phase
              materials and molecular phases, ceramic polymer materials,
              conducting materials, magnetic and electrical materials, phase
              diagrams, processing and development of microstructure/
              composites. Performance of materials and devices. Designing with
              different materials, performance criteria and standards. Selected
              case studies of material selection.
            </p>
            <h4>
              PHY346.1 Advanced Materials Science Laboratory (For Materials
              Science Students)
            </h4>
            <p>
              This course is designed to introduce the students with
              specialization in material Science to basic principles of
              experimentation using different types of materials. Simple
              experiments that show how materials behave under different
              environmental exposures will be carried out. Visits to materials
              industries and Engineering materials workshop is a vital part of
              this practical course.
            </p>
            <h4>PHY 350.2: Industrial Training</h4>
            <p>
              This course is designed to introduce the students to the everyday
              practices in the industries. The students are attached to the
              related industries for a period ranging from three to six months
              under the national SIWES program. The students are supervised by
              the high-level industrial personnel. University supervisors make
              unannounced visits to the sites to monitor the progress of the
              students at least twice during the department. The students are
              expected to write a details report of their program and present an
              oral report to the staff and students of the department after the
              program.
            </p>
            <h4>PHY351.1 Electronics I</h4>
            <p>
              To introduce students to the techniques of electronic measurements
              and application of relevant electronic instruments and components.
              Electron emission and the devices (Schottky, Zener, Tunnel and LED
              etc) semi-conductor devices (FET, MSFET and Tunnel Diodes),
              Oscillators, Different types of amplifiers, e.g., transistor
              amplifiers, operational amplifiers, power amplifiers and
              differential amplifiers. Filters and rectification process-half
              and full wave rectification-smoothing, three phase rectifier
              networks. Analysis and design of multistage amplifier network,
              junction diodes, light emitting diode photo-cell
            </p>
            <h4>
              PHY 356.2 Advanced Electronics Workshop (Electronics students)
            </h4>
            <p>
              This course is designed to introduce the students with
              specialization in Electronics to basic principles of electronic
              experimentation. Simple experiments that show how electricity is
              controlled by using devices called components and IC’s would be
              applied to illustrate the principles of circuit designing. Other
              topics to be covered will include testing and designing of
              circuits, trouble shooting, analysis, hoe to solder, case study
              and a mini-designed and tested circuit.
            </p>
            <h4>
              PHY 362.1 Geophysical Explorations I – Gravity and Magnetics
            </h4>
            <p>
              This course is a continuation of PHY 361.1 and is an introductory
              aspect of Geophysical exploration using gravity and magnetic
              methods. Gravitational acceleration and potential; Application of
              Newton’s Law. The earth’s gravitational field and its relation to
              Gravity Exploration. Instruments for measuring gravity on land and
              Fundamental principles and Instruments. Basic concepts; Magnetism
              of the earth. Susceptibility of Rocks; Magnetic effects of Bodies.
              Interpretation of magnetic data.
            </p>
          </div>
          <div className={`panel ${checkActive(4, "active2")}`}>
            <h3>400 Level</h3>
            <h4>PHY 408.1 Computational Physics & Numerical Method</h4>
            <p>
              Using of numerical methods in Physics, various methods of
              numerical integration, differentiation, numerical solutions of
              some differential equations in Physics. Statistical analysis of
              experimental data, numerical solution of non-linear algebraic
              equations, Polynomials and zeros of polynomials; numerical
              solution of systems of linear algebraic equations; interpolation;
              least squares and curve fitting. Calculus of residues and
              application to various physical situations. Sturn-Lioville theory;
              uniqueness of solutions. Solution of ordinary differential
              equations; Linear equations, finite difference method for boundary
              value problems. Non-linear equations, Runge-Kutta and Shooting
              algorithms. Method of quasi-linearization. Partial differential
              equations: parabolic equations, explicit finite, differences
              scheme. Implicit scheme. Elliptic and hyperbolic equations and
              finite differences. Finite element methods.
            </p>
            <h4>PHY 409.1 Physical Optics</h4>
            <p>
              Wave equation in rectangular and polar coordinates, superposition
              of waves; production of coherent sources by division of wave
              fronts and of amplitude; applications. Michelson and Jamin
              Interferometers with applications. Multiple beam interference by
              division of amplitude and wave front-Fabry-Perot etalon, Fresnel
              and Fraunhoffer diffraction patterns, polarization of lights.
            </p>
            <h4>PHY 412.1 Problem solving and Technical Writing</h4>
            <p>
              The aim of this course is to introduce students to an important
              aspect of any research finding – Reporting, presenting your
              results in an attractive way. Also, it is important that an
              undergraduate student should be able to define, analyse and
              possibly attempt to find solutions to the problem. The course will
              cover: Introduction to problem formulation, identification,
              analysis and solutions. The main scientific approach to different
              types of problem. Examples could be drawn from the natural world,
              engineering and the prevailing, environmental problems. At the end
              of this section, the student should be able to formulate, analyse
              and suggest solutions to social problems in a scientific manner.
              General introduction to technical writing (hints on planning,
              current, presentation and conclusions), Different types of writing
              and how they relate to the audience. Specific presentation of
              thesis with special reference to layout, abstract, introduction,
              conclusion and referencing other materials. Writing a
              dissertation, journal paper, technical reports. Presenting
              seminars, special projects and research reports. Project proposals
              and how to apply for research grants. Writing the first draft,
              editing and rewriting you own writing. Writing the submittal
              letters. Responding to corrections suggested by reviewers and
              correcting proofs. The importance of units and their
              abbreviations, general abbreviation s and standard symbols.
              Figures and how to captions your figures. Expression to avoid and
              apply in your writings.
            </p>
            <h4>PHY 435.1 Mechanical Properties of Materials</h4>
            <p>
              Behaviour of different types of materials under stress. Mechanical
              properties of materials in tension, compression, direct shear,
              torsion flexure. True stress-strain. Cold work, hardness, impact
              and fatigue characteristics of materials. Creep and stress
              rupture. Effect of temperature/environment on mechanical behaviour
              of materials. Mechanism of slip, slip systems. Criteria of
              resolved shear stress and mechanical twinning and deformation in
              polycrystalline materials. Impurity effect and yield point
              phenomena. Introduction to elements of dislocation theory
              dislocation reactions. Multiplication movement under force.
              Dislocation interaction with impurities and point defects.
            </p>
            <h4>PHY 442.1 Solid State Physics I</h4>
            <p>
              Crystal structure, Diffraction Studies in solids and X-ray
              crystallography and its experimental methods. Theory of solid,
              classical free electron theory, quantum theory of electron gas and
              the band theory of solids. Electrical and thermal properties of
              solids.
            </p>
            <h4>PHY 444.1 Engineering Materials I</h4>
            <p>
              Introduction of Material Science with emphasis on physical
              metallurgy, Classes of Materials, Polymers, ceramics, woods,
              metals and composite materials, structure, properties and
              applications of polymers, ceramics and metal. Effects of crystal
              structures, defects and heat-treatment on materials. Relation of
              properties (Electrical, optical and mechanical) to microstructure.
              Recovery, recrystallization and grain growth. Phase diagrams,
              Solidification of liquid metals and alloys, casting process
              defects. Cold and hot working processes (pressing, forging,
              extrusion, deep drawing, rolling, casting, etc.). Metallography
              Optical microscope and introduction to electron microscopy.
            </p>
            <h4>PHY 455.1 Electronics Instrumentation II</h4>
            <p>
              Primary sensing elements: Electrical filters, Mechanical springs,
              Pressure sensitive elements, Flow-rate sensing elements. The
              principles and practical aspects of transducers (types of
              transducers and other systems used to measure and control some
              physical parameters such as: Force, acceleration, temperature,
              pressure, light intensity, humidity, vibration). Signal
              conditioning and conversion, Transducers bridge, Instrumentation
              amplifiers, analog-Digital data and sampling; A/D and D/A
              converters, interference, grounding, screens and shielding, noise
              reduction. Signal recovery; signal filtering, signal averaging,
              signal correlation, signal coding. Uses of operational amplifier
              and digital systems. Modulation and filter circuits.
            </p>
            <h4>PHY 414.2: Electricity and Magnetism II</h4>
            <p>
              Continuation of PHY 313.1. Topics include polarization,
              dispersion, reflection and refraction of EM. Waves guided waves,
              radiating systems resonance cavities transmission lines,
              diffraction and electrodynamics.
            </p>
            <h4>PHY 434.2 Atomic and Nuclear Physics</h4>
            <p>
              Nuclear structure and properties; Nuclear models and nuclear
              reactions; vector model of the atom. Nuclear spectroscopy; X-ray
              spectra; alkali spectra. A Zeeman and Stark effect. Fundamental
              particles, strong and weak electromagnetic interactions.
              Resonance.
            </p>
            <h4>PHY 436.2 Powder Metallurgy and Ceramics</h4>
            <p>
              Characteristics of metal powders. Basic principles of compacting
              and powder processing. Porous and dense products as they relate to
              microstructure of materials. Factors affecting physical and
              mechanical properties of powder. Powder blending, compacting,
              sintering etc. Sources of mineral raw materials for powder
              production. Introduction to ceramics; Ceramics processing
              techniques. Forming and thermal treatment of clay materials to
              obtain ceramic products. Glasses, glazes, enamels and metals
              (metallization). Equilibrium and reactions between ceramics.
              Recrystallization, grain growth and microstructure of ceramics
              that make them unique. Solidification of liquid metals and alloys,
              casing processes and defects. Cold and hot working processes of
              pressing, forging, extrusion, deep drawing, rolling, casting, etc.
              metallography –Optical microscope and introduction to electron
              microscopy.
            </p>
            <h4>PHY 441.2 Modern Materials and Trends</h4>
            <p>
              Physics of coating paints, Gels and Nanomaterial’s. Surface
              coating terminology and classification. Thin film coatings
              (metallic, optical, semiconductor and selective materials),
              production and applications of Nano materials. Paint Manufacture
              and applications. Types of adhesives and binders. Theory of
              adhesion developments and adhesive strength. Formulation of
              adhesives. Production of Gels and colloids and their applications.
              Other current and future innovative materials.
            </p>{" "}
            <h4>PHY 443.2 Solid State Physics II</h4>
            <p>
              Bond theory of insulators and semi-conductors, Lattice Vibrations,
              Models for lattice heat capacity, classical model, Einstein model,
              Debye model, phonons, thermal conductivity, dielectrics and
              ferroelectrics, Magnetism in solids, magnetic resonance,
              imperfections in solids, Super-conductivity
            </p>{" "}
            <h4>PHY 449.2 Project</h4>
            <p>
              Topics for research projects will be assigned near the end of the
              student’s third year. The projects may be of a theoretical or
              experimental nature.
            </p>{" "}
            <h4>PHY 450.2 Seminar</h4>
            <p>
              Emphasis will be on topics of current interest in all areas of
              physics and applied physics.
            </p>{" "}
            <h4>PHY 452.2 Electronics II</h4>
            <p>
              This course introduces students to the application of feedback
              theory in measurement and digital electronics. Feedback theory;
              type, networks and applications. The concept of small, medium,
              large and very large integration and their consequences, Boolean
              algebra and the nature of two-value variables. Boolean functions
              and production methods. Logic gates and switching devices, logic
              design, and minimization technique’s reliability design
              synchronous sequential and combination logic circuits. Analysis of
              logic gates of various families. Some digital building, blocks.
              Flip-flop counters, latch registers and detectors. Diode logic,
              RTL, DECL, Moss and MOSIC. Introduction to D/A and AID conversion
              principles. Microprocessors, microprocessor control, flow charts,
              programs, simple instruction set and control programs.
            </p>{" "}
            <h4>PHY 454.2 Microwaves (Antennas and Propagation)</h4>
            <p>
              Theory dipole antenna arrays, beam shaping. Types of antennas,
              antenna gain. E.M. wave propagation, Noise, guided waves and wave
              guide structure. Cavity resonators and types of resonators
            </p>{" "}
            <h4>PHY 457.2 Network Analyses</h4>
            <p>
              This course involves the application of basic mathematical
              principles to electric circuits. In general, network analysis is
              concerned with determining the response, given the excitation and
              the network. In network synthesis, the student will be taught how
              to design the network given the excitation and desired response.
              The course outline includes: Current analysis including modal and
              mesh analysis, equivalent circuits, phasor and complex notations.
              Signals, systems and waveform. The frequency, Fourier analysis,
              Different equations, Network Analysis, Network elements, Initial
              and final conditions, transfer function concepts and types of
              response, Transform, Properties of Transforms, uses, Partial
              Fraction Expansions, Poles and Zeros, evaluation of Residues,
              Initial and Network functions, Two-port parameters, transfer
              function, Incidental Dissipation, Ladder.
            </p>{" "}
            <h4>PHY 461.1 Geophysical data processing I</h4>
            <p>
              Introduction to data Processing, seismic data of enhancement
              Processes. Operating characteristics of digital computers used in
              Data Processing. Digital filtering and Convolution. Practical
              aspects of data processing. Seismic section and presentation.
              Practical processing flow.
            </p>{" "}
            <h4>PHY 462.1 Geophysical prospecting II – Other Methods</h4>
            <p>
              Electrical Prospecting methods including DC Resistivity Methods;
              Telluric, Magnetotelluric, induced Polarization, Use of Electrical
              Methods of prospecting for ground water.
            </p>{" "}
            <h4>PHY 463.2 Geophysical Data Processing II</h4>
            <p>
              Special techniques of enhancement of geophysical data including
              multiple suppression techniques, migration, Amplitude-versus –
              offset (AVO) and Current techniques in data enhancement.
            </p>{" "}
            <h4>PHY 464.2 Practical Methods</h4>
            <p>
              This course is designed to introduce the students to
              specialization in the techniques for data collection, and analysis
              through experiments. Simple experiments in applied geophysics with
              emphasis on practical work will be carried out. New techniques
              will also be introduced when they arise.
            </p>
            <h4>PHY 490.2 Statistical Physics </h4>
            <p>
              Fundamentals of probability theory: concept of probability
              density, addition, multiplication, average values, fluctuation and
              normal distribution. Basic of statistical physics: macro state,
              micro state, phase space statistical ensemble, classical and
              quantum distributions. Liouville’s Theorem, micro-canonical
              ensemble, canonical ensemble and grand-canonical ensembles.
            </p>
            <h3>ELECTIVES: </h3>
            <h4>PHY 411.2 Applied Geophysics (for non-Geophysics majors)</h4>
            <p>
              Introduction to Applied Geophysical methods including gravity,
              electrical and magnetic methods, electromagnetic surveys, seismic
              methods, nuclear geophysical methods. Areas of application of the
              above methods; Introduction to data processing and interpretation.
              Geophysical instrument involved in the various methods.
            </p>
            <h4>PHY 418.2 Meteorology</h4>
            <p>
              Introduction, the Atmosphere, Earth in space, Pressure, density
              and wind, water in the atmosphere, atmospheric stability, clouds
              and precipitation, atmospheric circulation systems, mid-latitude
              low pressure systems and weather at its worst.{" "}
            </p>
            <h4>PHY 420.2 Modern Cosmology and High Energy Astrophysics</h4>
            <p>
              Introduction to high-energy Astrophysics (X-rays, gamma-rays and
              radio source detection). Aspects of steller Evolution relating to
              compact objects, Supernovae, compact objects (black holes, white
              Dwarfs, Neutron stars). Galactic centre, Accretion/Accretion
              Disks, Accretion in Binary system, Shocks, cosmic Rays, Gamma-ray
              Bursts, Solar Corona and active Galactic Nuclear and Galaxy
              Clusters.{" "}
            </p>
            <h4>GEM 306.1 Geographic and Information System</h4>
            <p>
              Method of storing geographic data charts and diagram of various
              sorts, air photo, satellite images, etc. introduction to computer
              application of storing geographic data-relevant types of
              hardware’s and software’s. The use of scanning technology to store
              and preserve drawings and maps on digital form. Methods and tools
              necessary to convert scanned images into vector format, image
              processing. The application of GIS and conservation,
              transportation planning and management and several of other
              aspects of spatial policy decision.{" "}
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />

        <p></p>
        <h4></h4>
        <p></p>
        <h4></h4>
        <p></p>
      </div>
      <div className="col-md-12 lecturers-section mtt">
        <center>
          <h1>Our Leadership</h1>
          <p>There are many variations of passages of Lorem Ipsum</p>
        </center>
        <div className="flexy flexyM offset-md-5 col-md-2 offset-2">
          {" "}
          <div className="bb ">&nbsp;</div>
          <img className="" src={Image4} alt="Scholar" width="20%" />
          <div className="bb ">&nbsp;</div>
        </div>
        {/* <Carousel
          show={isMobile ? 1 : 3}
          slide={1}
          autoSwipe={0}
          transition={0.9}
          swiping={true}
          infinite={true}
          useArrowKeys={true}
        > */}{" "}
        <div className="row row-cols-2 row-cols-lg-4  g-lg-2 col-md-8 offset-md-2 mt8">
          {state.list.map((data, index) => (
            <Lecturers data={data} />
          ))}
        </div>
        {/* </Carousel> */}
      </div>
    </>
  );
};
